import AdvancedReport from "features/reports/AdvancedReport/AdvancedReport";

export default function PartnerStatistics() {
  return (
    <AdvancedReport
      title="Statisztikák"
      visibleFilters={[]}
      visibleValues={[
        "amount",
        "canceled_amount",
        "canceled_count",
        "canceled_guests",
        "count",
        "guests",
        "refund_amount",
        "refund_guests",
      ]}
    />
  );
}
